import {Injectable, inject} from '@angular/core';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {translate} from '@jsverse/transloco';
import {DocumentPreviewDialogComponent} from './document-preview-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DocumentPreviewDialogService {
  private readonly dialogService = inject(DialogService);

  open(blob: Blob): DynamicDialogRef<DocumentPreviewDialogComponent> | null {
    return this.dialogService.open(DocumentPreviewDialogComponent, {
      width: '90%',
      header: translate('document.preview.title'),
      closable: true,
      modal: true,
      closeOnEscape: true,
      dismissableMask: true,
      data: {blob},
    });
  }
}
